import * as z from "zod/v4";

export const getProactiveClaimsStats = {
  name: "getProactiveClaimsStats" as const,
  input: z.object({}),
  output: z.object({
    proactiveClaimCount: z.number(),
    estimatedMerchantSavings: z.number(),
  }),
};
